<template>
  <div>
    <!-- Nav tabs-->
    <ul :id="crowdfunding ? 'crowdtabs' : 'raistabs'" role="tablist" class="nav nav-tabs">
      <li>
        <a v-if="crowdfunding" class="first">CROWDFUNDING:</a>
        <a v-else class="first">FUNDRAISING:</a>
      </li>
      <li v-for="(value, key) in projects" role="presentation" v-if="value[0]" :class="{ 'active': activeTab() === key }">
        <a :href="`#${key}`" aria-controls="rais-recommended" role="tab" data-toggle="tab">
          {{ $t(`main.${key}`) }}
        </a>
      </li>
      <li>
        <router-link v-if="crowdfunding" :to="{ name: 'crowdfunding'}" >{{ $t("main.seeAll") }}</router-link>
        <router-link v-else :to="{ name: 'fundraising'}">{{ $t("main.seeAll") }}</router-link>
      </li>
    </ul>
    <!-- Tab panes-->
    <div class="tab-content">
      <div v-for="(value, key) in projects"
        :id="`${key}`" role="tabpanel"
        :class="['tab-pane fade', { 'in active': activeTab('fundraising') === key }]">
        <div v-if="crowdfunding" class="row">
          <crowdfunding-tile  v-for="project in value" :key="project.id" :project="project" :size="'col-md-6'"></crowdfunding-tile>
        </div>
        <div v-else class="row">
          <fundraising-tile v-for="project in value" :key="project.id" :project="project" :size="'col-md-4'"></fundraising-tile>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FundraisingTile from '@/components/Project/Tiles/Fundraising';
import CrowdfundingTile from '@/components/Project/Tiles/Crowdfunding';

export default {
  components: { FundraisingTile, CrowdfundingTile },
  props: {
    projects: {
      type: Object,
      required: true,
      default() {
        return {
          popular: [],
          ending: [],
          littleMissing: [],
        };
      },
    },
    crowdfunding: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    activeTab() {
      if (this.projects.popular[0]) {
        return 'popular';
      } else if (this.projects.littleMissing[0]) {
        return 'littleMissing';
      }
      return 'ending';
    },
  },
};
</script>



// WEBPACK FOOTER //
// Tabs.vue?c785fa94